import { render, staticRenderFns } from "./Orgs.vue?vue&type=template&id=4406b315"
import script from "./Orgs.vue?vue&type=script&lang=js"
export * from "./Orgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports